import CourseDetails from './courseDetails';
import { useMetadata } from 'hooks/useMetadata'; // Import the hook

export default function PageCourseDetails() {
  useMetadata({
    page: 'course'
  });

  return (
    <CourseDetails />
  );
}
